import { useState } from 'react'
import {
	EuiButton,
	EuiPopover,
} from '@equipmentshare/ds2'
import RentalsTable from '../RentalsTable'
import { StorePartsQuery } from '../../../../../graphql'

export type rentalItems = NonNullable<StorePartsQuery['storeParts']>[number]['rentalItems']
export type Rental = NonNullable<rentalItems>[number]
export type RentalsPopoverProps = {
	rentals: Rental[],
}

export default function RentalsPopover( { rentals }: RentalsPopoverProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )
	const quantity = rentals.reduce( ( total, rental ) => total + rental.quantityOnRent, 0 )

	if ( quantity === 0 ) {
		return null
	}

	const button = (
		<EuiButton
			color="text"
			onClick={() => setIsPopoverOpen( !isPopoverOpen )}
			size="s"
		>
			{quantity} {quantity === 1 ? 'item' : 'items'}
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isPopoverOpen}
			closePopover={() => setIsPopoverOpen( false )}
		>
			<RentalsTable rentals={rentals} />
		</EuiPopover>
	)
}
